import {StyleSheet, Dimensions} from 'react-native';

const {width, height} = Dimensions.get('window');

// Responsive utility functions
export const responsiveWidth = (percentage: number) =>
  (width * percentage) / 100;
export const responsiveHeight = (percentage: number) =>
  (height * percentage) / 100;
export const responsiveFontSize = (size: number) =>
  Math.round((size * width) / 375); // 375 is a standard mobile width

const styles = StyleSheet.create({
  gradient: {
    flex: 1,
  },
  container: {
    paddingTop: 20,
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
    borderRadius: 24,
    marginHorizontal: 12,
    marginVertical: 12,
    paddingHorizontal: 16,
    paddingVertical: 20,
    shadowColor: '#E8D5FF',
    shadowOffset: {width: 0, height: 8},
    shadowOpacity: 0.15,
    shadowRadius: 20,
    elevation: 12,
    borderWidth: 1,
    borderColor: 'rgba(232, 213, 255, 0.3)',
    flexGrow: 1,
    alignSelf: 'stretch',
  },
  scrollContent: {
    flexGrow: 1,
    paddingBottom: 80,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  card: {
    padding: responsiveWidth(4),
    width: '100%',
    maxWidth: '100%',
    alignSelf: 'stretch',
  },
  gridContainer: {
    flexDirection: 'row',
    marginBottom: 10,
    paddingHorizontal: 10,
    paddingVertical: 5,
    alignItems: 'center',
    borderBottomWidth: 1,
    borderColor: '#ddd',
    borderRadius: 4,
    height: 50,
  },
  row: {
    flexDirection: 'row',
    width: '100%',
    marginBottom: 10,
  },
  col: {
    flex: 1,
    paddingHorizontal: 5,
    minWidth: 0,
  },
  rowSec: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowHead: {
    padding: 2,
    borderTopWidth: 2,
    borderBottomWidth: 2,
    borderBottomColor: '#d9d9d9',
    borderTopColor: '#d9d9d9',
    backgroundColor: '#d9d9d9',
    flexDirection: 'row',
    color: '#000',
    fontSize: 16,
    fontWeight: 'bold',
  },
  linkBtn: {
    width: '90%',
    backgroundColor: '#3b5998',
    borderRadius: 25,
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 10,
  },
  buttonText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: 'white',
  },
  logoutBtn: {
    width: '90%',
    backgroundColor: '#d9534f',
    borderRadius: 25,
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: 10,
  },
  app: {
    flex: 1,
    backgroundColor: '#F6F1F1',
  },
  // Responsive utilities
  responsiveContainer: {
    width: '100%',
    maxWidth: '100%',
    paddingHorizontal: 16,
  },
  responsiveCard: {
    width: '100%',
    maxWidth: '100%',
    alignSelf: 'stretch',
  },
  separator: {
    height: 1,
    width: '86%',
    backgroundColor: '#CED0CE',
    marginLeft: '14%',
  },
  conLstItem: {
    padding: 2,
    borderBottomWidth: 0.5,
    borderBottomColor: '#AFD3E2',
    width: '100%',
  },
  button: {padding: 1, textAlign: 'center'},
  text: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
  },
  heading: {
    color: '#000',
    fontSize: 16,
  },
  iconCol: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    textAlign: 'center',
    width: 42,
  },
  conLstData: {
    flex: 1,
    justifyContent: 'center',
    paddingLeft: 3,
    paddingVertical: 5,
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    marginBottom: 5,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.2,
    shadowRadius: 1,
    elevation: 3,
  },

  descr: {
    color: '#6B7280',
    fontSize: 14,
    fontWeight: '600',
  },
  rate: {
    color: '#4B5563',
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'right',
  },
  qty: {
    color: '#888',
    fontSize: 14,
    fontWeight: '600',
    width: 70,
    textAlign: 'center',
  },
  amt: {
    color: '#1D4ED8',
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'right',
  },
  avatarAvailable: {
    backgroundColor: '#adf7b6',
  },
  avatarOccupied: {
    backgroundColor: '#ffc09f',
  },
  avatarReserved: {
    backgroundColor: '#a0ced9 ',
  },
  available: {
    backgroundColor: '#E8F8F5',
  },
  occupied: {
    backgroundColor: '#FDEDEC',
  },
  reserved: {
    backgroundColor: '#FEF9E7',
  },
  statusText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#666',
    marginTop: 4,
  },
  loading: {
    flex: 1 / 5,
    padding: 5,
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomWidth: 0.5,
    borderBottomColor: '#d9d9d9',
    fontSize: 25,
  },
  itemContainer: {
    flex: 1 / 5,
    padding: 3,
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomWidth: 0.5,
    borderBottomColor: '#d9d9d9',
  },
  conImg: {
    alignItems: 'center',
  },
  avatar: {
    width: 65,
    height: 65,
    borderRadius: 30,
    backgroundColor: '#B9F3E4',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar1: {
    width: 65,
    height: 65,
    borderRadius: 30,
    backgroundColor: '#EA8FEA',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar2: {
    width: 65,
    height: 65,
    borderRadius: 30,
    backgroundColor: '#E1D323',
    alignItems: 'center',
    justifyContent: 'center',
  },
  txt: {
    fontSize: 18,
    color: '#000',
  },
  proddescr: {
    color: '#888',
  },
  amount: {
    color: '#888',
    textAlign: 'right',
  },
  amount1: {
    color: '#000',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'right',
  },
  headingAmt: {
    color: '#000',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'right',
  },
  iconBtn: {
    backgroundColor: '#28A745',
    padding: 1,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 6,
  },
  iconBtn1: {
    backgroundColor: '#FF6B6B',
    padding: 1,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 6,
  },
  scrollView: {
    backgroundColor: '#F0F0F0',
  },
  orderContainer: {
    margin: 10,
    padding: 10,
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  headerContainerRed: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
    backgroundColor: '#E17423',
  },
  headerContainerBlue: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
    backgroundColor: '#23E1C7',
  },
  headerContainerGreen: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
    backgroundColor: '#DAF7A6',
  },
  headerLeft: {
    alignItems: 'flex-start', // Aligns content to the left
  },
  headerCenter: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  headerRight: {
    alignItems: 'flex-end', // Aligns content to the right
  },
  headerText: {
    fontSize: 18,
    color: '#333333',
    fontWeight: 'bold',
  },
  detailHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 5,
    borderBottomWidth: 1,
    borderBottomColor: '#EAEAEA',
    marginBottom: 5,
  },
  detailHeaderText: {
    fontSize: 16,
    color: '#555555',
    fontWeight: 'bold',
  },
  itemRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 2,
    borderBottomWidth: 1,
    borderBottomColor: '#EAEAEA',
  },
  itemDescr: {
    fontSize: 16,
    color: '#555555',
    flex: 3,
    textAlign: 'left',
  },
  itemQty: {
    fontSize: 16,
    color: '#555555',
    flex: 1,
    textAlign: 'right',
  },
  actionButtons: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 10,
  },
  item: {
    borderStyle: 'solid',
    borderColor: '#AFD3E2',
    borderWidth: 2,
    padding: 15,
  },
  amt1: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  glossyRect: {
    backgroundColor: '#F8F4FF',
    padding: 24,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 20,
    width: '100%',
    shadowColor: '#D4C4F0',
    shadowOffset: {width: 0, height: 8},
    shadowOpacity: 0.25,
    shadowRadius: 16,
    elevation: 12,
    borderWidth: 1,
    borderColor: 'rgba(212, 196, 240, 0.4)',
  },
  glossOverlay: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '50%',
    backgroundColor: '#ffffff40',
    borderBottomRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderRadius: 20, // Ensuring the overlay is also rounded
  },
  grid: {
    marginBottom: 20,
  },
  textRight: {
    textAlign: 'right',
  },
  gridHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2,
    paddingHorizontal: 16,
    paddingVertical: 16,
    backgroundColor: '#F0F8FF',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomWidth: 2,
    borderBottomColor: '#E6F3FF',
    shadowColor: '#B3D9FF',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
  },
  gridRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 14,
    backgroundColor: '#FFFEFF',
    borderBottomWidth: 1,
    borderBottomColor: '#F5F0FF',
    marginHorizontal: 2,
    borderRadius: 4,
    shadowColor: '#E8D5FF',
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 2,
  },
  gridFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 16,
    backgroundColor: '#E8F5E8',
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    marginHorizontal: 2,
    shadowColor: '#A8D8A8',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 6,
    borderWidth: 1,
    borderColor: 'rgba(168, 216, 168, 0.3)',
  },
  gridText: {
    flex: 1,
    fontSize: 15,
    color: '#5A5A5A',
    fontWeight: '500',
  },
  bold: {
    fontWeight: 'bold',
  },
  chartTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 20,
    marginBottom: 5,
    textAlign: 'center',
  },
  legend: {
    marginLeft: 10,
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  legendIcon: {
    width: 20,
    height: 20,
    marginRight: 5,
  },
  legendText: {
    fontSize: 14,
    color: '#7F7F7F',
  },
  // Modern Dashboard Styles
  modernCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    marginVertical: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 4,
    borderWidth: 0.5,
    borderColor: 'rgba(232, 213, 255, 0.4)',
  },
  modernHeader: {
    fontSize: 20,
    fontWeight: '700',
    color: '#FFFFFF',
    marginBottom: 4,
    textAlign: 'center',
  },
  modernSubheader: {
    fontSize: 14,
    color: '#8B5CF6',
    textAlign: 'center',
    marginBottom: 16,
  },
  dateNavigation: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#F8F4FF',
    borderRadius: 20,
    padding: 20,
    marginHorizontal: 16,
    marginVertical: 12,
    shadowColor: '#D4C4F0',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.12,
    shadowRadius: 12,
    elevation: 6,
    borderWidth: 1,
    borderColor: 'rgba(212, 196, 240, 0.3)',
  },
  dateButton: {
    backgroundColor: '#E6F3FF',
    borderRadius: 16,
    padding: 16,
    shadowColor: '#B3D9FF',
    shadowOffset: {width: 0, height: 3},
    shadowOpacity: 0.15,
    shadowRadius: 6,
    elevation: 4,
    borderWidth: 1,
    borderColor: 'rgba(179, 217, 255, 0.3)',
  },
  dateText: {
    fontSize: 18,
    fontWeight: '600',
    color: '#6B46C1',
    textAlign: 'center',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#6B46C1',
    marginBottom: 16,
    textAlign: 'center',
  },
  chartContainer: {
    backgroundColor: '#FFFEFF',
    borderRadius: 20,
    padding: 24,
    marginHorizontal: 16,
    marginVertical: 12,
    shadowColor: '#E8D5FF',
    shadowOffset: {width: 0, height: 6},
    shadowOpacity: 0.12,
    shadowRadius: 16,
    elevation: 8,
    borderWidth: 1,
    borderColor: 'rgba(232, 213, 255, 0.4)',
  },
  footerText: {
    flex: 1,
    fontSize: 15,
    color: '#2D5A2D',
    fontWeight: '600',
  },
  // Modern Bill Styles
  modernHeaderContainer: {
    backgroundColor: '#6B46C1',
    paddingVertical: 20,
    paddingHorizontal: 20,
    shadowColor: '#6B46C1',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  modernHeaderTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 40,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: '#6B7280',
    fontWeight: '500',
  },
  emptyStateText: {
    fontSize: 16,
    color: '#9CA3AF',
    textAlign: 'center',
    paddingVertical: 20,
  },
  tablesGrid: {
    maxHeight: 200,
  },
  formRow: {
    marginBottom: 8,
  },
  billSection: {
    marginTop: 20,
    marginBottom: 16,
  },
  billHeader: {
    flexDirection: 'row',
    paddingVertical: 12,
    paddingHorizontal: 4,
    backgroundColor: '#F3F4F6',
    borderRadius: 8,
    marginBottom: 8,
  },
  billHeaderText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#374151',
  },
  billItemsContainer: {
    maxHeight: 300,
  },
  billItemRow: {
    flexDirection: 'row',
    paddingVertical: 10,
    paddingHorizontal: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  billItemDescription: {
    fontSize: 14,
    color: '#6B7280',
    fontWeight: '500',
  },
  billItemRate: {
    fontSize: 14,
    color: '#4B5563',
    fontWeight: '600',
  },
  billItemQty: {
    fontSize: 14,
    color: '#4B5563',
    fontWeight: '600',
  },
  billItemAmount: {
    fontSize: 14,
    color: '#10B981',
    fontWeight: '700',
  },
  billSummaryContainer: {
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    padding: 16,
    marginTop: 16,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  billSummaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  billSummaryLabel: {
    fontSize: 15,
    color: '#6B7280',
    fontWeight: '500',
  },
  billSummaryValue: {
    fontSize: 15,
    color: '#374151',
    fontWeight: '600',
  },
  billTotalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 12,
    marginTop: 8,
    borderTopWidth: 2,
    borderTopColor: '#6B46C1',
  },
  billTotalLabel: {
    fontSize: 18,
    color: '#374151',
    fontWeight: '700',
  },
  billTotalValue: {
    fontSize: 18,
    color: '#6B46C1',
    fontWeight: '700',
  },
  actionButtonsWrapper: {
    marginTop: 20,
    marginBottom: 40,
    paddingHorizontal: 16,
  },
  actionButtonsContainer: {
    flexDirection: 'row',
    gap: 12,
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  actionButton: {
    flex: 1,
  },
  actionButtonWrapper: {
    flex: 1,
  },
  actionButtonStyle: {
    marginTop: 0,
    marginBottom: 0,
  },
  // Cancel Order Styles
  cancelOrderHeader: {
    flexDirection: 'row',
    paddingVertical: 16,
    paddingHorizontal: 16,
    backgroundColor: '#F9FAFB',
    borderBottomWidth: 2,
    borderBottomColor: '#E5E7EB',
    marginBottom: 0,
    alignItems: 'center',
  },
  cancelOrderHeaderTextLeft: {
    fontSize: 13,
    fontWeight: '700',
    color: '#6B7280',
    letterSpacing: 0.5,
    flex: 2,
    textAlign: 'left',
    textTransform: 'uppercase',
  },
  cancelOrderHeaderTextCenter: {
    fontSize: 13,
    fontWeight: '700',
    color: '#6B7280',
    letterSpacing: 0.5,
    flex: 1,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  cancelOrderHeaderTextRight: {
    fontSize: 14,
    fontWeight: '700',
    color: '#374151',
    flex: 1.5,
    textAlign: 'right',
  },
  cancelOrderItem: {
    flexDirection: 'row',
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#F3F4F6',
    alignItems: 'center',
    minHeight: 72,
    backgroundColor: '#FFFFFF',
  },
  cancelOrderItemDescription: {
    flex: 2.2,
    paddingRight: 12,
    justifyContent: 'center',
  },
  cancelOrderItemDescriptionText: {
    fontSize: 14,
    color: '#1F2937',
    fontWeight: '500',
    lineHeight: 20,
    textAlign: 'left',
  },
  cancelOrderItemQty: {
    flex: 0.7,
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancelOrderItemText: {
    fontSize: 15,
    color: '#9CA3AF',
    fontWeight: '600',
    textAlign: 'center',
  },
  cancelOrderItemControls: {
    flex: 1.5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
  },
  qtyButton: {
    backgroundColor: '#8B5CF6',
    width: 38,
    height: 38,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#8B5CF6',
    shadowOffset: {width: 0, height: 3},
    shadowOpacity: 0.25,
    shadowRadius: 5,
    elevation: 5,
  },
  qtyButtonDisabled: {
    opacity: 0.25,
    backgroundColor: '#D1D5DB',
    shadowOpacity: 0,
    elevation: 0,
  },
  qtyInput: {
    minWidth: 58,
    maxWidth: 68,
    height: 38,
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: '#E5E7EB',
    paddingHorizontal: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default styles;

